import fomApi from "../../../services/fomApi";
export function applyFilter(selectedLocation) {
  return async function (dispatch) {
    const action = { type: "GET_ORDERS", payload: selectedLocation };
    dispatch(action);
  };
}
